import { CSSProperties } from "react"
import "/src/theme/colors.css"

export const cardAvatarIcons: CSSProperties = {
  width: "24px",
  height: "24px",
  fontSize: "12px",
}
